import React,{useState,useEffect} from 'react'
import { Loader } from '../../components/Default/Loader'
import { getUser } from '../../helpers'
import { AuthContext } from './Create'
import { initalize } from "../../socket/socket"
export const Provider=(props)=>{
 
  let [state,setState]=useState({
    user: null,
    isAuthenticated: false,
    loader:true,
    notification:[],
    themeColor:{},
    socket:initalize()
})
const setAuthenticationOnStart=async()=>{
  try{
   
    let userData=await getUser();
    const themeColor={
      colorRGB:window.app.color.whiteRgb,
      color:window.app.color.theme
    }
    setState((pre)=>{
        return{...pre,loader:false,user:userData,isAuthenticated: true,notification:[],themeColor:localStorage.getItem(`${process.env.NODE_ENV}-themecolor`)?localStorage.getItem(`${process.env.NODE_ENV}-themecolor`):themeColor} 
      })
    }catch(e){
    if(e.logout){
        setState((pre)=>{
          return{...pre,loader:false,user: null,isAuthenticated: false,notification:[]} 
           })
      }
   
  }
}
useEffect(()=>{
  const script=document.createElement("script");
  script.src="assets/js/init.js";
  script.async=true;
  document.body.appendChild(script);
  const script2=document.createElement("script");
  script2.src="assets/js/env.js";
  script2.async=true;
  document.body.appendChild(script2);
  setTimeout(() => {
    setAuthenticationOnStart()  
  }, 2000);
  return () => {
    document.body.removeChild(script);
    document.body.removeChild(script2);
  }
},[])
const setThemeColor=(color)=>{
  setState((pre)=>{
    return {...pre,themeColor:color}
  })
}
const updateState=async (user=false)=>{
  if(user){
    setState((pre)=>{
      return{...pre,user: user,isAuthenticated: true,notification:[]} 
    })
  }else{
   setState((pre)=>{
   return{...pre, user: null,isAuthenticated: false,notification:[]} 
    })
  }
  }
if(!state.loader){
const context={
        user: state.user,
        isAuthenticated: state.isAuthenticated,
        notification:state.notification,
        themeColor:state.themeColor,
        updateState:updateState,
        setThemeColor,
        socket:state.socket
       
      }
    return (
        <>
        <AuthContext.Provider value={context}>
        {props.children}
        </AuthContext.Provider>
        </>
    )
}
else{
    return (
    <>
   <Loader/>
    </>
    )
}
    
  
}